import { makeAutoObservable } from "mobx";

const MAX_CHAT_MESSAGES_PER_SERVER = 500;

export default class ChatStore {
    constructor() {
        this._chat = {};

        makeAutoObservable(this);
    }

    setChat(storage) {
        const { chat, data } = storage || {};

        if (typeof chat === "undefined" || chat === null || !Array.isArray(data)) {
            console.warn("Некорректные данные для setChat:", storage);
            return;
        }

        const current = this._chat[chat] || { chat, data: [] };
        const nextData = current.data.concat(data).slice(-MAX_CHAT_MESSAGES_PER_SERVER);

        this._chat = {
            ...this._chat,
            [chat]: {
                chat,
                data: nextData,
            },
        };
    }

    getStorageByChatId(chatId) {
        const chatData = this._chat[chatId];

        if (!chatData) {
            return { chat: chatId, data: [] };
        }

        return {
            chat: chatData.chat,
            data: [...chatData.data],
        };
    }

    reset() {
        this._chat = {};
    }

    get chat() {
        return this._chat;
    }
}
